import gql from 'graphql-tag';

export const all = gql`query getUnderwriterRates($companyId: ID!) {
    underwriterRates (companyId: $companyId){
        id
        name
        company {
            id
            name
        }
        rate
        yearOfAddition
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/underwriterRate.js